import Home from './Home.vue';
import createPage from '../../common/createPage.js';

createPage(Home);